import './login.css';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import SocialLogin from './SocialLogin';
import { useAuth } from '../AuthContext';


const apiUrl = process.env.REACT_APP_API_URL;

export const Login = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth(); 
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // Verifică dacă există mesaj de eroare în URL
    const error = searchParams.get('error');
    if (error) {
      setErrorMessage(decodeURIComponent(error));
      // Curăță URL-ul după 5 secunde
      setTimeout(() => {
        setErrorMessage('');
        navigate('/login', { replace: true });
      }, 8000);
    }
  }, [searchParams, navigate]);



  return (
    <div className='container-login'>
      <div className='login-card-wrapper'>
      

        {errorMessage && (
          <div className="error-message-google">
            <span className="error-icon">⚠️</span>
            <p>{errorMessage}</p>
          </div>
        )}

        <div>
          <SocialLogin allowDirectSignup />
        </div>

        <div className='redirect-registrer'>
          <b className='redirect-reg-text'>Nou pe Contalearn?</b>
          <Link to='/quiz-start' className='redirect-reg-link'>
            <b className='redirect-reg-link'>Creeaza-ti un cont</b>
          </Link>
        </div>
      </div>
    </div>
  );
};
